// Branding white label: judul (tab & login), logo (login & sidebar), favicon, "powered by" (login & footer).
// Halaman login mengenali perusahaan dari domain tempat aplikasi dibuka; setelah login dipakai perusahaan user.
// Dibaca lewat endpoint publik (tanpa token); gambar disajikan dari database lewat publik/branding_gambar.
// Branding terakhir disimpan di browser agar kunjungan berikutnya langsung tampil benar, tanpa sempat melihat tampilan bawaan.
import { reactive } from 'vue'
import axios from 'axios'
import appConfig from '@/utils/pengaturan'
import logoBawaan from '@/assets/images/wina.png'

// Versi dari package.json saat branding tidak mengisi versi; penanda build selalu dari build yang sedang berjalan
export const VERSI_BAWAAN = process.env.VUE_APP_VERSI || ''
export const BUILD_APLIKASI = process.env.VUE_APP_BUILD || ''

export const branding = reactive({ judul: 'WINA', logoPath: '', faviconPath: '', poweredBy: 'PT PPI (Persero)', poweredUrl: '', idPerusahaan: null, versi: VERSI_BAWAAN })

function apiUrl() {
  return localStorage.getItem('url') || appConfig.apiUrl
}

// Path dari server relatif ke index.php (mis. "publik/branding_gambar?p=3&j=logo&v=2")
function urlGambar(path) {
  return apiUrl() + path
}

// Ganti semua ikon tab/layar beranda (index.html punya banyak ukuran); href asli disimpan agar bisa dipulihkan
function terapkanFavicon() {
  document.querySelectorAll('link[rel~="icon"], link[rel="apple-touch-icon"]').forEach((el) => {
    if (!el.dataset.asli) el.dataset.asli = el.getAttribute('href')
    el.setAttribute('href', branding.faviconPath ? urlGambar(branding.faviconPath) : el.dataset.asli)
    if (branding.faviconPath) el.setAttribute('type', 'image/png')
  })
}

export function faviconUrl() {
  return branding.faviconPath ? urlGambar(branding.faviconPath) : '/favicon-96x96.png'
}

// URL logo aktif; logo bawaan aplikasi bila belum diganti
export function logoUrl() {
  return branding.logoPath ? urlGambar(branding.logoPath) : logoBawaan
}

export function terapkanBranding(data) {
  branding.judul = data?.judul || 'WINA'
  document.title = branding.judul // judul tab browser
  branding.logoPath = data?.logo || ''
  branding.faviconPath = data?.favicon || ''
  branding.poweredBy = data?.powered_by || 'PT PPI (Persero)'
  branding.poweredUrl = data?.powered_url || ''
  branding.idPerusahaan = data?.id_perusahaan || null
  branding.versi = data?.versi || VERSI_BAWAAN
  terapkanFavicon()
}

// Penyimpanan terpisah untuk domain (halaman login) dan tiap perusahaan; public/index.html membaca kunci yang sama
function kunciSimpan() {
  return 'branding_' + ((localStorage.getItem('auth_token') && localStorage.getItem('id_perusahaan')) || 'domain')
}

function bacaSimpanan() {
  try {
    return JSON.parse(localStorage.getItem(kunciSimpan()))
  } catch {
    return null
  }
}

function simpan(data) {
  try {
    localStorage.setItem(kunciSimpan(), JSON.stringify({ data, favicon: data?.favicon ? urlGambar(data.favicon) : '' }))
  } catch {
    // penyimpanan browser penuh atau diblokir: branding tetap dimuat dari server setiap kali
  }
}

// Logo diunduh dulu supaya tidak muncul belakangan setelah halaman tampil
function muatLogo() {
  return new Promise((selesai) => {
    const img = new Image()
    img.onload = selesai
    img.onerror = selesai
    img.src = logoUrl()
  })
}

// Dipanggil sebelum aplikasi tampil. Ada simpanan: langsung dipakai, data terbaru menyusul di belakang.
// Kunjungan pertama: menunggu server. Bila server lambat, setelah batas waktu tampil dengan branding bawaan.
export function siapkanBranding(batasMs = 2500) {
  const simpanan = bacaSimpanan()
  if (simpanan) terapkanBranding(simpanan.data)
  const terbaru = loadBranding()
  const siap = (simpanan ? Promise.resolve() : terbaru).then(muatLogo)
  return Promise.race([siap, new Promise((selesai) => setTimeout(selesai, batasMs))]).then(() => {
    if (!branding.faviconPath) terapkanFavicon()
    if (!document.title) document.title = branding.judul
  })
}

// Sebelum login: dari domain. Sesudah login: perusahaan user (perusahaan tanpa branding sendiri ikut bawaan / domain).
export async function loadBranding() {
  const login = !!localStorage.getItem('auth_token')
  const simpanan = bacaSimpanan()
  if (simpanan) terapkanBranding(simpanan.data)
  try {
    const res = await axios.post(
      apiUrl() + 'publik/branding',
      { host: window.location.hostname, id_perusahaan: login ? localStorage.getItem('id_perusahaan') || '' : '' },
      { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
    )
    if (res.data.status === 'success') {
      terapkanBranding(res.data.data)
      simpan(res.data.data)
    }
  } catch {
    // server tidak terjangkau: tetap tampil dengan logo & teks bawaan
  }
}
